import { useState, useEffect } from 'react';

/**
 * Custom hook to detect online/offline network status
 * @returns {boolean} isOnline - true if connected, false if offline
 */
const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      console.log('📶 Connexion internet rétablie');
    };

    const handleOffline = () => {
      setIsOnline(false);
      console.log('📵 Connexion internet perdue');
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};

export default useNetworkStatus;
